// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import OffenceService from '@services/offence'

export const getTrafficInfringements = createAsyncThunk('trafficInfringements/getTrafficInfringements', async (params) => {
  const response = await OffenceService.getTrafficInfringementsForForeigner(params)
  try {
    return {
      params,
      data: response.data,
      // allData: response.data,
      totalPages: response.meta.itemCount
    }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getTrafficInfringementsById = createAsyncThunk('trafficInfringements/getTrafficInfringementsById', async (id) => {
  const response = await OffenceService.getTrafficInfringementsForForeignerById(id)
  return response
})

export const addTrafficInfringements = createAsyncThunk('trafficInfringements/addTrafficInfringements', async (trafficInfringements, { rejectWithValue }) => {
  try {
    const response = await OffenceService.addTrafficInfringementsForForeigner(trafficInfringements)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const updateTrafficInfringements = createAsyncThunk('trafficInfringements/updateTrafficInfringements', async (trafficInfringements, { rejectWithValue }) => {
  try {
    const response = await OffenceService.updateTrafficInfringementsForForeigner(trafficInfringements)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const deleteTrafficInfringements = createAsyncThunk('trafficInfringements/deleteInspectionPlaces', async (id, { getState, dispatch }) => {
  await OffenceService.deleteInspectionPlaces(id)
  await dispatch(getInspectionPlaces(getState()?.vehicleFitnesses?.params))
  return id
})

export const paymentForTrafficInfringements = createAsyncThunk('trafficInfringements/paymentForTrafficInfringements', async (paymentInfo, { rejectWithValue }) => {
  try {
    const response = await OffenceService.paymentForTrafficInfringementsForForeigner(paymentInfo)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const updateTrafficInfringementsPaymentAmount = createAsyncThunk('trafficInfringements/updateTrafficInfringementsPaymentAmount', async (paymentInfo, { rejectWithValue }) => {
  try {
    const response = await OffenceService.updateTrafficInfringementsPaymentAmountForForeigner(paymentInfo)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const cancelTrafficInfringementsForForeigner = createAsyncThunk('trafficInfringements/cancelTrafficInfringementsForForeigner', async (trafficInfringements, { rejectWithValue }) => {
  try {
    const response = await OffenceService.cancelOffenceForForeigner(trafficInfringements)
    return response
  } catch (err) {
    console.log(err.response)
    return rejectWithValue(err.response)
  }
})

export const updateTrafficInfringementsForForeignerAttachment = createAsyncThunk('trafficInfringements/updateTrafficInfringementsForForeignerAttachment', async (data, { rejectWithValue }) => {
  try {
    const id = data.get('id')
    const response = await OffenceService.updateTrafficInfringementForeignerAttachment(id, data)
    return response.data
  } catch (err) {
    console.log(err)
    return rejectWithValue(err.response.data)
  }
})

export const searchTrafficInfringementsForForeigner = createAsyncThunk('trafficInfringements/searchTrafficInfringementsForForeigner', async (searchTerm, { rejectWithValue }) => {
  try {
    const response = await OffenceService.searchTrafficInfringementsForForeigner(searchTerm)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const cancellationAttachmentForForeigner = createAsyncThunk('trafficInfringements/cancellOffenceForeignerAttachment', async (data, { rejectWithValue }) => {
  console.log('kjhk')
  try {
    const id = data.get('id')
    const response = await OffenceService.cancellationAttachmentForForeigners(id, data)
    return response.data
  } catch (err) {
    console.log(err.response)
    return rejectWithValue(err.response.data)
  }
})

export const trafficInfringementsForForeignerSlice = createSlice({
  name: ' trafficInfringementsForForeigner',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    individualTrafficInfringements: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTrafficInfringements.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getTrafficInfringementsById.fulfilled, (state, action) => {
        state.individualTrafficInfringements = action.payload
      })
  }
})

export default trafficInfringementsForForeignerSlice.reducer
